import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { FaChartLine, FaArrowUp, FaArrowDown, FaPercentage, FaBox, FaUser } from 'react-icons/fa';
import { PriceChangeStats } from '../../../../types';
import './StatCards.scss';

interface StatCardsProps {
  stats: PriceChangeStats;
}

const StatCards: React.FC<StatCardsProps> = ({ stats }) => {
  const formatCurrency = (value: number): string => {
    const absValue = Math.abs(value);
    return `${value >= 0 ? '+' : '-'}$${Math.round(absValue).toLocaleString('es-CL')}`;
  };

  const formatPercentage = (value: number): string => {
    return `${value >= 0 ? '+' : ''}${value.toFixed(1)}%`;
  };

  return (
    <div className="price-stat-cards">
      <Row>
        <Col lg={4} md={6} sm={12} className="mb-3">
          <Card className="stat-card">
            <Card.Body>
              <div className="stat-icon chart">
                <FaChartLine />
              </div>
              <div className="stat-content">
                <div className="stat-label">Total de Cambios</div>
                <div className="stat-value">{stats.totalChanges}</div>
                <div className="stat-detail">
                  <span className="increase">{stats.totalIncreases} aumentos</span>
                  <span className="separator">•</span>
                  <span className="decrease">{stats.totalDecreases} disminuciones</span>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} md={6} sm={12} className="mb-3">
          <Card className="stat-card">
            <Card.Body>
              <div className={`stat-icon ${stats.avgPriceChange >= 0 ? 'increase' : 'decrease'}`}>
                {stats.avgPriceChange >= 0 ? <FaArrowUp /> : <FaArrowDown />}
              </div>
              <div className="stat-content">
                <div className="stat-label">Cambio Promedio</div>
                <div className={`stat-value ${stats.avgPriceChange >= 0 ? 'positive' : 'negative'}`}>
                  {formatCurrency(stats.avgPriceChange)}
                </div>
                <div className="stat-detail">
                  {formatPercentage(stats.avgPercentageChange)} en promedio
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} md={6} sm={12} className="mb-3">
          <Card className="stat-card">
            <Card.Body>
              <div className="stat-icon percentage">
                <FaPercentage />
              </div>
              <div className="stat-content">
                <div className="stat-label">Variación Promedio</div>
                <div className="stat-value">
                  {formatPercentage(stats.avgPercentageChange)}
                </div>
                <div className="stat-detail">
                  Porcentaje de cambio
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {stats.mostChangedProduct && (
          <Col lg={6} md={6} sm={12} className="mb-3">
            <Card className="stat-card">
              <Card.Body>
                <div className="stat-icon product">
                  <FaBox />
                </div>
                <div className="stat-content">
                  <div className="stat-label">Producto Más Modificado</div>
                  <div className="stat-value small-text">
                    {stats.mostChangedProduct.product_name}
                  </div>
                  <div className="stat-detail">
                    {stats.mostChangedProduct.count} cambios de precio
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        )}

        {stats.topUserByChanges && (
          <Col lg={6} md={6} sm={12} className="mb-3">
            <Card className="stat-card">
              <Card.Body>
                <div className="stat-icon user">
                  <FaUser />
                </div>
                <div className="stat-content">
                  <div className="stat-label">Usuario con Más Cambios</div>
                  <div className="stat-value small-text">
                    {stats.topUserByChanges.user_name}
                  </div>
                  <div className="stat-detail">
                    {stats.topUserByChanges.count} modificaciones realizadas
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default StatCards;
